import React, { Component } from "react";


class Loader extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
      this.props.loading &&
      <div className="pdfLoader">
        <div className="spinner-bubble spinner-bubble-info mt-5"></div>
        {this.props.text && <div className=""><h4>{this.props.text}</h4></div>}
      </div>
    );
  }
}

export default Loader;
